export default __webpack_public_path__ + "static/media/card_1.cd064c4f.png";